angular.module('aprima-core-ui').directive('apDateRangeFormatter',
    [function () {
        'use strict';

        return {
            restrict: 'AEC',
            scope: {
                startDate: '=',
                endDate: '=',
                format: '@',
                multiline: '='
            },
            templateUrl: '/core-ui/views/directives/apDateRangeFormatter.html'
        };
    }]);
